import categoryConfig from './categories.json';
import translations from '~/Assets/Locale/en.json';
import { useTranslation } from 'react-i18next';

export const useSportCatgeroy = () => {
  const { t } = useTranslation();
  const getCategory = (tranlationId: any) => {
    const assetCategory = (translations as any)?.[`event.sportCategory.${tranlationId}`];
    const uscCatgerory = categoryConfig?.items?.find(({ id }) => `${id}` === `${tranlationId}`);
    let translation = `event.sportCategory.${tranlationId}`;
    if (!!assetCategory) {
      translation = t(`event.sportCategory.${tranlationId}`);
    } else if (!!uscCatgerory) {
      translation = uscCatgerory?.name;
    }
    return translation;
  };
  return { getCategory };
};
